import { useIsLoggedInRetailerOrBrandPreview } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  useSettingFaireDirectSignupForVisitorXP,
} from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";
import { useMemo } from "react";

import { getFaireDirectBrandFromTokenOrAlias } from "./__internal__/getFaireDirectBrandFromTokenOrAlias";
import { useFaireDirectBrandsForVisitor } from "./__internal__/useFaireDirectBrandsForVisitor";
import { BrandTokenOrBrandAlias } from "./faireDirectTypes";

export const useIsFaireDirectBrandForVisitor = (
  params: BrandTokenOrBrandAlias
) => {
  const isFaireDirectCreditForVisitorXP =
    useSettingFaireDirectSignupForVisitorXP();
  const { faireDirectBrandsForVisitor, isPending } =
    useFaireDirectBrandsForVisitor();

  const isFaireDirectBrandForVisitor = useMemo(() => {
    if (!isFaireDirectCreditForVisitorXP || !params) {
      return false;
    }
    return (
      getFaireDirectBrandFromTokenOrAlias(
        params,
        faireDirectBrandsForVisitor
      ) !== undefined
    );
  }, [
    isFaireDirectCreditForVisitorXP,
    params,
    faireDirectBrandsForVisitor,
  ]);

  return {
    isPending,
    isFaireDirectBrandForVisitor,
  };
};

export const useIsFaireDirectActiveForVisitor = (
  params: BrandTokenOrBrandAlias,
  isFaireDirectActiveInControl: boolean
) => {
  const { isFaireDirectBrandForVisitor, isPending } =
    useIsFaireDirectBrandForVisitor(params);
  const isFaireDirectCreditForVisitorXP =
    useSettingFaireDirectSignupForVisitorXP();
  const isLoggedInRetailerOrBrandPreview =
    useIsLoggedInRetailerOrBrandPreview();
  if (isLoggedInRetailerOrBrandPreview) {
    return isFaireDirectActiveInControl;
  }
  if (isFaireDirectCreditForVisitorXP && isPending) {
    return false;
  }
  return isFaireDirectCreditForVisitorXP
    ? isFaireDirectBrandForVisitor
    : isFaireDirectActiveInControl;
};
